var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v(_vm._s(_vm.pageTitle))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dayForceId,
                              expression: "dayForceId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "dayForceId",
                            placeholder: "Day Force Id"
                          },
                          domProps: { value: _vm.dayForceId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.dayForceId = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.dayForceIdError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactEmail,
                              expression: "contactEmail"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "contactEmail",
                            placeholder: "Contact Email"
                          },
                          domProps: { value: _vm.contactEmail },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.contactEmail = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.contactEmailError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.firstName,
                              expression: "firstName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "firstName",
                            placeholder: "First Name"
                          },
                          domProps: { value: _vm.firstName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.firstName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.firstNameError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastName,
                              expression: "lastName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "lastName",
                            placeholder: "Last Name"
                          },
                          domProps: { value: _vm.lastName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.lastNameError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "reportTo",
                              id: "reportTo",
                              label: "text",
                              filterable: false,
                              options: _vm.reportToArr,
                              placeholder: "Select User"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueUser()
                              },
                              search: _vm.onSearchUser
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(option.text) +
                                          "\n                                            "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(option.text) +
                                            "\n                                            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.reportTo,
                              callback: function($$v) {
                                _vm.reportTo = $$v
                              },
                              expression: "reportTo"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                            Search User...\n                                        "
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "roleId",
                              id: "roleId",
                              label: "text",
                              filterable: false,
                              options: _vm.roleArr,
                              placeholder: "Select Role"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueRole()
                              },
                              search: _vm.onSearchRole
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(option.text) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.roleId,
                              callback: function($$v) {
                                _vm.roleId = $$v
                              },
                              expression: "roleId"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                        Search Role...\n                                    "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.designationError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "locationId",
                              id: "locationId",
                              label: "text",
                              filterable: false,
                              options: _vm.locationArr,
                              placeholder: "Select State"
                            },
                            on: {
                              change: _vm.changedValue,
                              input: function($event) {
                                return _vm.changedValueLocation()
                              },
                              search: _vm.onSearchLocation
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(option.text) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.locationId,
                              callback: function($$v) {
                                _vm.locationId = $$v
                              },
                              expression: "locationId"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                        Search State...\n                                    "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.locationError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("v-select", {
                          attrs: {
                            name: "siteId",
                            id: "siteId",
                            label: "text",
                            options: _vm.siteArr,
                            searchable: false,
                            filterable: false,
                            placeholder: "Select Location"
                          },
                          on: {
                            input: function($event) {
                              return _vm.changedValueSite()
                            }
                          },
                          model: {
                            value: _vm.siteId,
                            callback: function($$v) {
                              _vm.siteId = $$v
                            },
                            expression: "siteId"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.siteError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("v-select", {
                          attrs: {
                            name: "departmentId",
                            id: "departmentId",
                            label: "text",
                            options: _vm.departmentArr,
                            searchable: false,
                            filterable: false,
                            placeholder: "Select Department"
                          },
                          on: {
                            input: function($event) {
                              return _vm.changedValueDepartment()
                            }
                          },
                          model: {
                            value: _vm.departmentId,
                            callback: function($$v) {
                              _vm.departmentId = $$v
                            },
                            expression: "departmentId"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.departmentError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.post,
                              expression: "post"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "post",
                            placeholder: "Post",
                            maxlength: "190"
                          },
                          domProps: { value: _vm.post },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.post = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.postError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 forms-block",
                        attrs: { id: "pro_pic_id" }
                      },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 paddingleft0" },
                          [
                            _c("vue-dropzone", {
                              ref: "dropzone",
                              attrs: {
                                id: "drop1",
                                options: _vm.dropzoneOptions,
                                destroyDropzone: false,
                                headers: _vm.dropzoneOptions.headers,
                                name: "file"
                              },
                              on: {
                                "vdropzone-removed-file":
                                  _vm.removedSelectedFile,
                                "vdropzone-success": _vm.vfileSuccess
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _c("strong", {
                                staticClass: "error text-danger",
                                attrs: { id: "uploadErrorMsg" }
                              })
                            ])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 paddingleft0" },
                        [
                          _c("vue-croppie", {
                            ref: "croppieRef",
                            attrs: {
                              id: "vuecrop",
                              viewport: {
                                width: 276,
                                height: 312,
                                type: "square"
                              },
                              boundary: { width: 286, height: 322 },
                              enableResize: false
                            },
                            on: { result: _vm.result, update: _vm.update }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 paddingleft0" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn-croppie",
                              attrs: {
                                id: "rotateAnti",
                                type: "button",
                                title: "Rotate Left"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.rotate(-90)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-repeat",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-croppie",
                              attrs: {
                                id: "rotateClock",
                                type: "button",
                                title: "Rotate Right"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.rotate(90)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-undo",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-croppie",
                              attrs: {
                                id: "crop",
                                type: "button",
                                title: "Crop"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.crop()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-crop",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("img", {
                            attrs: { src: _vm.cropped, width: "200" }
                          }),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.cropError))
                          ])
                        ],
                        1
                      )
                    ])
                  ],
                  _vm._v(" "),
                  _vm._m(11),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "col-12 paddingleft0" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addBenifitBtn",
                          type: "submit",
                          value: "Save"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addNotRegisterdUser()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addAndContinueBenifitBtn",
                          type: "submit",
                          value: "Save and Continue"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addNotRegisterdUser(
                              (_vm.flag = "Save and Continue")
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "back_button btn btn-primary",
                        attrs: {
                          id: "CancelBenifit",
                          type: "submit",
                          value: "Cancel"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.buttonBack.apply(null, arguments)
                          }
                        }
                      })
                    ])
                  ])
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "dayForceId" } }, [
        _vm._v("Day Force Id :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "contactEmail" } }, [
        _vm._v("Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "firstName" } }, [
        _vm._v("First Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "lastName" } }, [
        _vm._v("Last Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "username" } }, [
        _vm._v("Reporting To :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "roleData" } }, [
        _vm._v("Designation :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "siteId" } }, [
        _vm._v("Location :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "departmentId" } }, [
        _vm._v("Department :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "post" } }, [
        _vm._v("Post :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop1" } }, [
        _vm._v("Profile Picture :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49676580", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49676580","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/notregisteredusers/AddNotRegisteredUser.vue
// module id = null
// module chunks = 